import { render } from "./SummaryCourse.vue?vue&type=template&id=2c063396&scoped=true"
import script from "./SummaryCourse.vue?vue&type=script&lang=js"
export * from "./SummaryCourse.vue?vue&type=script&lang=js"

import "./SummaryCourse.vue?vue&type=style&index=0&id=2c063396&lang=scss&scoped=true"

import exportComponent from "D:\\programmazione\\pronails\\MemsionPrivato\\front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c063396"]])

export default __exports__